import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Illinois = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Illinois Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Residential Real Property Disclosure Act requires a specific form.
        </Text>

        <Text style={styles.listItem}>
          2. Radon Disclosure: Mandatory for residential transactions.
        </Text>

        <Text style={styles.listItem}>
          3. Attorney Review Period: Standard practice, often included in
          contracts.
        </Text>

        <Text style={styles.listItem}>
          4. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          5. <Text style={styles.underline}>Property Disclosure Report</Text> –
          This form must be completed by the seller and provided to the buyer
          before signing a purchase agreement.
        </Text>

        <Text style={styles.listItem}>
          6. <Text style={styles.underline}>Radon Hazards Disclosure</Text> –
          This form must be completed by the seller to disclose any radon
          hazards.
        </Text>
      </View>
    </View>
  );
};

export default Illinois;
